/**
  * vue-cal v3.11.0
  * (c) 2022 Antoni Andre <antoniandre.web@gmail.com>
  * @license MIT
  */
const e = ["Ponedeljek", "Torek", "Sreda", "\u010Cetrtek", "Petek", "Sobota", "Nedelja"], a = ["Januar", "Februar", "Marec", "April", "Maj", "Junij", "Julij", "Avgust", "September", "Oktober", "November", "December"], t = "Leta", d = "Leto", o = "Mesec", s = "Teden", n = "Dan", r = "Danes", k = "Ni dogodkov", l = "Cel dan", v = "Odstrani", M = "Ustvari dogodek", y = "dddd MMMM D, YYYY", D = { weekDays: e, months: a, years: "Leta", year: "Leto", month: "Mesec", week: "Teden", day: "Dan", today: "Danes", noEvent: "Ni dogodkov", allDay: "Cel dan", deleteEvent: "Odstrani", createEvent: "Ustvari dogodek", dateFormat: "dddd MMMM D, YYYY" };
export {
  l as allDay,
  M as createEvent,
  y as dateFormat,
  n as day,
  D as default,
  v as deleteEvent,
  o as month,
  a as months,
  k as noEvent,
  r as today,
  s as week,
  e as weekDays,
  d as year,
  t as years
};
